import { Outlet } from 'react-router-dom';

import { ROUTES } from 'constants/routes';
import CustomerDeliveryFileDownloadPage from 'pages/customer-delivery-files/customer-delivery-file-download';
import ExternalDeliveryFileDownloadPage from 'pages/external-delivery-files/external-delivery-file-download';

export const FILE_DOWNLOAD_ROUTES = {
  path: '',
  element: <Outlet />,
  children: [
    {
      path: `${ROUTES.FILE_DOWNLOAD.CUSTOMER_DELIVERY_FILE.path}/:fileId`,
      element: <CustomerDeliveryFileDownloadPage />,
    },
    {
      path: `${ROUTES.FILE_DOWNLOAD.EXTERNAL_DELIVERY_FILE.path}/:fileId`,
      element: <ExternalDeliveryFileDownloadPage />,
    },
  ],
};
